import React from "react";
import SectionHeader from "./SectionHeader";
import Input from "../util/Input";
import Select from "../util/Select";
import { PropTypes } from "prop-types";
import { Checkbox } from "@kui/foundations-react";

// Contact address block. When the company address section is shown, the contact address
// defaults to "same as company address" and its fields are only revealed when unticked.
// When there is no company section (PEC already valid) this is the only address.
const PrimaryContactDetails = props => {
  const fe = props.fieldErrors || {};
  const showFields = props.pecProvided || props.useAltAddress;

  return (
    <div className='AppSection regSection'>
      {!props.pecProvided && (
        <Checkbox
          checked={!props.useAltAddress}
          onCheckedChange={checked =>
            props.handleAltAddressChange({ target: { checked: checked === true } })
          }
          slotLabel='Address same as Organization/Company address'
        />
      )}
      {showFields && (
        <>
          <SectionHeader
            title={props.pecProvided ? "Address" : "Contact Address"}
            showHr={false}
          />
          <Select
            labelText={"Country/Region"}
            optionValues={props.countries}
            isRequired={true}
            value={props.country}
            onChange={props.handleCountryChange}
            errorText={fe.altCountry}
            displayFieldName='countryName'
            valueFieldName='id'
          />
          <div className='regRow regRow--2'>
            <Input
              labelText={"Address Line 1"}
              placeholder='Enter address line 1'
              isRequired={true}
              value={props.street1}
              onChange={props.handleStreet1Change}
              errorText={fe.altStreet1}
              maximumLength={40}
            />
            <Input
              labelText={"Address Line 2"}
              placeholder='Enter address line 2'
              value={props.street2}
              onChange={props.handleStreet2Change}
              maximumLength={40}
            />
          </div>
          <div className='regRow regRow--3'>
            <Input
              labelText={"City"}
              placeholder='Enter city'
              isRequired={true}
              value={props.city}
              onChange={props.handleCityChange}
              errorText={fe.altCity}
              maximumLength={40}
            />
            <Select
              labelText={"State/Province"}
              optionValues={props.states}
              isRequired={true}
              value={props.state}
              onChange={props.handleStateChange}
              errorText={fe.altState}
              readOnly={props.states[0].id === -1}
              displayFieldName='stateName'
              valueFieldName='id'
            />
            <Input
              labelText={"Zip/Postal Code"}
              placeholder='Enter zip/postal code'
              isRequired={true}
              value={props.zip}
              onChange={props.handleZipChange}
              errorText={fe.altZip}
              maximumLength={10}
            />
          </div>
        </>
      )}
    </div>
  );
};

PrimaryContactDetails.propTypes = {
  street1: PropTypes.string,
  street2: PropTypes.string,
  city: PropTypes.string,
  countries: PropTypes.array,
  country: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  states: PropTypes.array,
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  zip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleStreet1Change: PropTypes.func.isRequired,
  handleStreet2Change: PropTypes.func.isRequired,
  handleCityChange: PropTypes.func.isRequired,
  handleCountryChange: PropTypes.func.isRequired,
  handleStateChange: PropTypes.func.isRequired,
  handleZipChange: PropTypes.func.isRequired,
  pecProvided: PropTypes.bool.isRequired,
  useAltAddress: PropTypes.bool.isRequired,
  handleAltAddressChange: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object
};

export default PrimaryContactDetails;
